import { render } from "./UnauthorizedError.vue?vue&type=template&id=54ede0ec"
import script from "./UnauthorizedError.vue?vue&type=script&lang=js"
export * from "./UnauthorizedError.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__